<template>
  <div class="app-file_afi">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">
      <div class="el-upload__tip afi_choose-tip" slot="tip">
      Ограничений на размер и тип файлов нет</div>

      <div class="error-message" v-if="isLoading && showLoadingError">
        {{ validateMessages.isLoading }}
      </div>

      <div
        v-for="(vl, i) in valueLocal"
        :key="`app-file-input-group-${i}`"
        class="input-group"
        :class="{ 'is-loading': vl.isLoading, 'is-loaded': vl.uploadedFilename }"
        @click="removeError(i)">

        <div class="afi_input-wrap">

        <el-upload
          :ref="`app-file-upload-${i}`"
          :limit="1"
          :file-list="fileList[i]"
          :headers="headers"
          :action="`${$store.state.apiUrl}files/upload`"
          :on-change="onChange"
          :on-progress="onProgress"
          :before-remove="beforeRemove"
          :on-remove="onRemove"
          :on-success="onSuccess">
          <div class="afi_choose-btn">
            <el-button
              slot="trigger"
              size="small"
              class="afi_load-file">
              Загрузить файл
            </el-button>
          </div>
        </el-upload>

        <div class="afi_size" v-show="valueLocal[i].size">
          <span class="afi_size-title">Размер файла</span>
          {{ sizeInMb(valueLocal[i].size) }} Мб
        </div>

        <div class="markup-file" v-show="showMarkup(i)">
          <button
            @click="sendToMarkup(vl)"
            class="markup-file-btn">
            Фрагментировать
          </button>
        </div>

        <div class="markup-info" v-show="valueLocal[i].markup">
          Файл успешно фрагментирован.
          Фрагментов: {{ getMarkupFragments(i) }}.
          Заимствований: {{ getMarkupCitations(i) }}.
        </div>

        <el-progress
          v-if="valueLocal[i].hashProgress"
          :stroke-width="2"
          :percentage="valueLocal[i].hashProgress"/>

        </div>

        <div v-if="error[i]" class="ait_message ait_message--error">
          {{ error[i] }}</div>

        <div class="sub-title">Описание файла</div>

        <el-input
          v-model="valueLocal[i].description"
          maxlength="200"/>

        <!--<button
          v-if="i + 1 < valueLocal.length"
          class="arb_btn arb_btn&#45;&#45;remove">
          <i class="el-icon-delete"></i> удалить
        </button>-->

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import approve from 'approvejs';
import sha256 from '../../../helpers/sha256';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: {
        uploadedFilename: '',
        userFilename: '',
        hash: '',
        mime: '',
        size: 0,
        description: '',
        hashProgress: 0,
        hashStopNow: false,
        isLoading: false,
        fileId: '',
        markup: '',
      },
      fileList: [],
      isLoading: false,
      isLoadingGroup: [],
      showLoadingError: false,
      errorBase: '',
      hashWorkers: [],
      validateMessages: {
        required: 'Загрузите файл',
        isLoading: 'Дождитесь завершения загрузки файлов',
        isHashing: 'Дождитесь завершения обработки файла',
      },
      stopLoadingIndex: -1,
    };
  },

  created() {
    // Init empty value
    if (!this.value.length) {
      this.addInput();
    }
  },

  computed: {

    headers() {
      const token = this.$store.getters['user/getAuthToken'];
      const headers = {};
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
      return headers;
    },

  },

  methods: {

    getMarkupFragments(index) {
      let fragments = 0;
      if (this.valueLocal[index].markup) {
        Object.keys(this.valueLocal[index].markup).some((key) => {
          if (typeof this.valueLocal[index].markup[key].total_frag !== 'undefined') {
            fragments = this.valueLocal[index].markup[key].total_frag;
            return true;
          }
          return false;
        });
      }
      return fragments;
    },

    getMarkupCitations(index) {
      let citations = 0;
      if (this.valueLocal[index].markup) {
        Object.keys(this.valueLocal[index].markup).some((key) => {
          if (typeof this.valueLocal[index].markup[key].total_cit !== 'undefined') {
            citations = this.valueLocal[index].markup[key].total_cit;
            return true;
          }
          return false;
        });
      }
      return citations;
    },

    showMarkup(refIndex) {
      if (!this.options.showMarkupDialog ||
        !this.valueLocal[refIndex].size ||
        !this.valueLocal[refIndex].uploadedFilename) return false;
      const possibleMime = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword',
        'text/plain',
        'application/rtf'];
      if (possibleMime.includes(this.valueLocal[refIndex].mime)) return true;
      return false;
    },

    sendToMarkup(file) {
      if (file.fileName === '') this.$message.error('Для отправки на фрагментацию загрузите файл.');
      else this.$root.$emit('sendToMarkup', file);
    },

    sizeInMb(val) {
      const mb = 1024 * 1024;
      return Math.round((val / mb) * 100) / 100;
    },

    addInput() {
      this.fileList.push([]);
      this.valueLocal.push(Object.assign({}, this.valueBase));
      this.error.push(this.errorBase);
    },

    removeInput() {
      this.valueLocal.pop();
      this.error.pop();
      this.fileList.pop();
      this.$forceUpdate();
    },

    setValue(value) {
      this.valueLocal = value;
      if (value.length && value[0].uploadedFilename) {
        this.fileList = new Array(value.length);
        value.forEach((v, i) => {
          this.fileList[i] = [{ name: v.userFilename }];
        });
      }
      this.$forceUpdate();
    },

    getIndexByFile(file) {
      const refNames = Object.keys(this.$refs);
      for (let refIndex = 0; refIndex < refNames.length; refIndex += 1) {
        const ref = this.$refs[refNames[refIndex]];
        if (ref.length && ref[0].uploadFiles.length && ref[0].uploadFiles[0].name) {
          if (ref[0].uploadFiles[0].name === file.name) {
            return refIndex;
          }
        }
      }
      return -1;
    },

    onChange(file) {
      if (typeof file === 'undefined') return;
      const refNames = Object.keys(this.$refs);
      let count = 0;
      let clearRef = null;
      for (let refIndex = 0; refIndex < refNames.length; refIndex += 1) {
        const ref = this.$refs[refNames[refIndex]];
        if (ref.length && ref[0].uploadFiles.length) {
          if (ref[0].uploadFiles[0].name === file.name) {
            count += 1;
            if (ref[0].uploadFiles[0].status === 'ready') {
              clearRef = ref[0];
            }
          }
        }
      }
      if (count > 1 && clearRef) {
        clearRef.abort(file);
        clearRef.clearFiles();
        this.$message.error('Нельзя загружать в один объект файлы с одинаковыми названиями.');
      }
    },

    onProgress(event, file) {
      if (typeof file === 'undefined' || file.status === 'success') return;
      this.isLoading = true;
      const i = this.getIndexByFile(file);
      if (i > -1) {
        this.valueLocal[i].isLoading = true;
        this.$forceUpdate();
      }
    },

    onSuccess(response, file) {
      // Change loading status
      this.loadingStopped();
      // Set values
      Object.keys(this.$refs).forEach((refKey, refIndex) => {
        if (this.$refs[refKey].length && this.$refs[refKey][0].uploadFiles.length) {
          const refResponse = this.$refs[refKey][0].uploadFiles[0].response;
          if (refResponse === file.response) {
            sha256.hash(file.raw, this.valueLocal[refIndex]).then((hash) => {
              this.valueLocal[refIndex].uploadedFilename = response;
              this.valueLocal[refIndex].userFilename = file.name;
              this.valueLocal[refIndex].hash = hash;
              this.valueLocal[refIndex].mime = file.raw.type;
              this.valueLocal[refIndex].size = file.raw.size;
              this.valueLocal[refIndex].markup = '';
              this.error[refIndex] = this.errorBase;
              this.$forceUpdate();
            }).catch(() => { });
          }
        }
      });
    },

    beforeRemove(file) {
      if (this.fileId) this.fileId = '';
      const i = this.getIndexByFile(file);
      if (this.valueLocal[i].hashProgress) {
        this.valueLocal[i].hashStopNow = true;
      }
      Object.keys(this.valueBase).forEach((key) => {
        this.valueLocal[i][key] = this.valueBase[key];
      });
      this.error[i] = this.errorBase;
      this.stopLoadingIndex = i;
    },

    onRemove() {
      this.valueLocal[this.stopLoadingIndex].isLoading = false;
      this.stopLoadingIndex = -1;
      this.$forceUpdate();
    },

    loadingStopped() {
      this.isLoading = false;
      this.showLoadingError = false;
      // this.valueLocal.forEach((v, i) => {
      //   this.valueLocal[i].isLoading = false;
      // });
    },

    getError() {
      // Validate isLoading
      if (this.isLoading) {
        this.showLoadingError = true;
        return [this.validateMessages.isLoading];
      }
      // Validate isHashing
      this.valueLocal.forEach((value, i) => {
        if (value.hashProgress) {
          this.error[i] = this.validateMessages.isHashing;
        }
      });
      // Validate if required
      if (this.options.required) {
        const requiredFields = ['uploadedFilename', 'userFilename', 'size'];
        this.valueLocal.forEach((value, i) => {
          requiredFields.forEach((requiredField) => {
            if (this.error[i]) return;
            const result = approve.value(value[requiredField], { required: true });
            this.error[i] = result.approved ? this.errorBase : this.validateMessages.required;
          });
        });
      }
      this.$forceUpdate();
      return this.error;
    },

  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.app-file_afi {
  .afi_size {
    font-size: 14px;
    margin: 1px 0 0 4px;
    font-weight: 300;
    color: #fff;
    .afi_size-title {
      display: inline-block;
      margin-right: 3px;
      color: #b2b2b2;
    }
  }
  .markup-info {
    margin: 1px 0 0 4px;
    color: #b2b2b2;
    font-size: 14px;
  }
  .markup-file {
    .markup-file-btn {
      padding: 5px;
      cursor: pointer;
      @include border-radius;
      background: transparent;
      color: #fff;
      border: 1px solid #d85486;
      @include transition;
      margin-bottom: 10px;
      &:hover {
        background: #d85486;
      }
    }
  }
  .el-upload-list__item {
    margin-bottom: 4px;
    &:hover {
      background: rgba(255, 255, 255, .1);
    }
  }
  .el-progress__text {
    color: #fff;
  }
  .el-upload-list__item-name {
    cursor: default !important;
    &:hover {
      color: #fff;
    }
  }
  .input-group {
    border-bottom: 1px dotted rgba(255, 255, 255, .3);
    padding-bottom: 32px;
    &:last-of-type {
      border-bottom: none;
      padding-bottom: 20px;
    }
    &.is-loading,
    &.is-loaded {
      .afi_choose-btn,
      .el-upload--text {
        display: none;
      }
    }
  }
  .sub-title {
    margin: 15px 0 10px;
    font-size: 15px;
    color: #fff;
    opacity: .7;
    font-weight: 300;
  }
  .el-upload__tip {
    color: #b2b2b2;
    font-size: 14px;
    margin: 0 0 0 1px;
  }
  .afi_load-file {
    @include border-radius;
    background: transparent;
    color: #fff;
    border: 1px solid #d85486;
    @include transition;
    margin-bottom: 10px;
    &:hover {
      background: #d85486;
    }
  }
  .afi_choose-tip {
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppFile.vue